import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as Highcharts from 'highcharts';
import { GoogleAnalyticsService } from '@ascschool/core/services/google-analytics.service';
import { NzCarouselComponent } from 'ng-zorro-antd/carousel';
import { PieChart } from '@ascschool/model/chart/pie-chart.model';
import { ChartService } from '@ascschool/services/chart/chart.service';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { CommonFilter } from '@ascschool/model/commonfilter/commonfilter';
import { ProvinceService } from '@ascschool/services/category/province.service';
import { SchoolService } from '@ascschool/services/organization/school.service';
import { UtilsService } from '@ascschool/services/utils.service';
import { map } from 'rxjs/operators';
import { AuthQuery } from '@ascschool/core/auth/auth.query';
import { ButtonType } from '@ascschool/interface/setting';
import { element } from 'protractor';

interface DataEmloyeeCarosel {
    title: string;
    icon: string;
    idChart: string;
    total: number;
}
interface DataDoBCarosel {
    title: string;
    dob: string;
    avatarUrl: string;
    position: string;
}
@Component({
    selector: 'board',
    templateUrl: './board.component.html',
    styleUrls: ['./board.component.scss']
})
export class BoardComponent implements OnInit, AfterViewInit {
    @ViewChild('carousel1', { static: false }) myCarousel1: NzCarouselComponent;
    @ViewChild('carousel2', { static: false }) myCarousel2: NzCarouselComponent;
    @ViewChild('cardContent', { static: false }) elementCardContent: ElementRef;
    @ViewChild('cardContent2', { static: false }) elementCardContent2: ElementRef;
    Highcharts: typeof Highcharts = Highcharts;
    width: number;
    titleC1: string;
    iconC1: string;
    totalC1: number;
    titleC2: string;
    dobC2: string;
    titleAgeStudent: string;
    titleTypeOfDisbility: string;
    titleTypeOfEducation: string;
    titleQTOfPersonnel: string;
    isloading: boolean;
    getProvinceACFn: (value: any) => Observable<any>;
    provinceSubscription: any;
    provinceControl = new FormControl();
    commonFilter = new CommonFilter();
    lstthongtin: any;
    breadcrumbs: string[] = ['Dashboard'];
    effect = 'scrollx';
    btnType: ButtonType;
    buttonTypeEnum = ButtonType;
    TotalAge = 0;
    TotalTypeOfDisbility = 0;
    TypeOfEducation = 0;
    TypeOfPersonnel = 0;
    gridStyle = {
        width: '100%',
        textAlign: 'center',
        height: '298px',
    };
    gridStyle2 = {
        width: '100%',
        textAlign: 'center',
        height: '613px'
    };
    gridStyle3 = {
        width: '100%',
        textAlign: 'center',
        height: '220px'
    };
    gridStyle4 = {
        width: '100%',
        textAlign: 'center',
        height: '270px'
    };
    constructor(private _googleAnalytics: GoogleAnalyticsService,
        private cdRef: ChangeDetectorRef,
        public chartService: ChartService,
        private provinceService: ProvinceService,
        private utilsService: UtilsService,
        private schoolService: SchoolService,
        private authQuery: AuthQuery,
    ) { }

    ngOnInit() {
        this.authQuery.userSetting$.subscribe(type => {
            if (type) {
                this.btnType = type.btnType;
            }
        });
        this.commonFilter.PageIndex = 1;
        this.commonFilter.PageSize = 20;
        this.loadProvince();
        this.search();
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.width = this.elementCardContent.nativeElement.offsetWidth - 2;
        }, 1);
        setTimeout(() => {
            this.GetRpQuantityAgeStudent();
            this.GetPieChartTypeOfDisbility();
            this.GetPieChartTypeOfEducation();
            this.GetRpQuantityTypeOfPersonnel();
        }, 50);
        this.cdRef.detectChanges();
    }
    onResize() {
        this.width = this.elementCardContent.nativeElement.offsetWidth - 2;
    }
    sendTwitterEventButton() {
        this._googleAnalytics.sendEvent('Share Twitter', 'button');
    }

    next(idC: number) {
        if (idC === 1) {
            this.myCarousel1.next();
        } else if (idC === 2) {
            this.myCarousel2.next();
        }
    }
    pre(idC: number) {
        if (idC === 1) {
            this.myCarousel1.pre();
        } else if (idC === 2) {
            this.myCarousel2.pre();
        }
    }
    //độ tuổi
    GetRpQuantityAgeStudent() {
        this.chartService.GetRpQuantityAgeStudent().subscribe((res) => {
            res.categories[0] = "Trên 60 tuổi";

            Highcharts.chart('chartQuantityAge', this.barChartOption(res.categories, res.series));

            res.series.forEach(element => {
                let sum = element.data.reduce((acc, cur) => acc + cur, 0);
                this.TotalAge += sum;
            });
            this.titleAgeStudent = 'THỐNG KÊ NGƯỜI KHUYẾT TẬT THEO ĐỘ TUỔI' + '  --  ' + "Tổng : ";
        });

    }
    GetPieChartTypeOfDisbility() {

        this.chartService.GetPieChartTypeOfDisbility().subscribe((res) => {
            Highcharts.chart('chartTypeOfDisbility', this.pieChartOption(res));
            res.forEach(element => {
                this.TotalTypeOfDisbility += element.quantity;
            });
            this.titleTypeOfDisbility = 'THỐNG KÊ NGƯỜI KHUYẾT TẬT THEO DẠNG TẬT' + '  --  ' + "Tổng : ";
        });
    }
    GetPieChartTypeOfEducation() {

        this.chartService.GetPieChartByTypeOfEducation().subscribe((res) => {
            Highcharts.chart('chartByTypeOfEducation', this.pieChartOptionByTypeofEducation(res));
            res.forEach(element => {
                this.TypeOfEducation += element.quantity;
            });
            this.titleTypeOfEducation = 'THỐNG KÊ CƠ SỞ GIÁO DỤC NGƯỜI KHUYẾT TẬT' + '  --  ' + "Tổng : ";
        });
    }
    GetRpQuantityTypeOfPersonnel() {

        this.chartService.GetRpQuantityTypeOfPersonnel().subscribe((res) => {
            Highcharts.chart('chartQTOfPersonnel', this.columChartOption(res.categories, res.series));
            res.series.forEach(element => {
                let sum = element.data.reduce((acc, cur) => acc + cur, 0);
                this.TypeOfPersonnel += sum;
            });
            this.titleQTOfPersonnel = 'THỐNG KÊ NHÂN SỰ' + '  --  ' + "Tổng : ";
        });
    }
    barChartOption(_categories, _series) {
        const barChartOption: any = {
            chart: {
                type: 'bar',
            },
            title: {
                text: '',
            },
            subtitle: {
                text: '',
            },
            xAxis: {
                categories: _categories,
                title: {
                    text: null,
                },
            },
            colors: ['#3498db', '#e74c3c'],
            yAxis: {
                min: 0,
                title: {
                    text: '',
                    align: 'high',
                },
                labels: {
                    overflow: 'justify',
                },
            },
            tooltip: {
                headerFormat:
                    '<span><b>{point.key}</b></span><table>',
                pointFormat:
                    '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y} người</b></td></tr>',
                footerFormat: '</table>',
                shared: true,
                useHTML: true,
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: false,
                    },
                },
            },
            legend: {
                reversed: true,
            },
            credits: {
                enabled: false,
            },
            series: _series,
        };
        return barChartOption;
    }
    columChartOption(_categories, _series) {
        const columChartOption: any = {
            chart: {
                type: "column",
            },
            title: {
                text: "",
            },
            xAxis: {
                categories: _categories,
                crosshair: true,
            },
            colors: ['#e74c3c', '#3498db'],
            credits: {
                enabled: false
            },
            tooltip: {
                headerFormat: "<tr><td><b>{point.key}</b></td><table>",
                pointFormat:
                    '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                    '<td style="padding:0"><b>{point.y} người</b></td></tr>',
                footerFormat: "</table>",
                useHTML: true,
            },
            plotOptions: {
                column: {
                    pointPadding: 0.2,
                    borderWidth: 0,
                },
            },
            series: _series,
        };
        return columChartOption;
    }
    pieChartOptionByTypeofEducation(_series) {
        const pieChartOption: any = {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
            },
            title: {
                text: '',
            },
            colors: ['#1abc9c', '#f39c12', '#3498db', '#8e44ad', '#c0392b', '#ecf0f1', '#e74c3c', '#f1c40f'],
            tooltip: {
                headerFormat: '{point.key}<br>',
                pointFormat:
                    '<span style="color:{series.color}>{series.name}</span>:{point.quantity} cơ sở<br>Tỷ lệ: {point.percentage:.0f} %',
            },
            accessibility: {
                point: {
                    valueSuffix: '%',
                },
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format:
                            '<span>{point.name}</span>: {point.percentage:.0f} %',
                    },
                    showInLegend: false
                },
            },
            series: [
                {
                    name: 'Số lượng',
                    data: _series,
                },
            ],
        };
        return pieChartOption;
    }
    pieChartOption(_series) {
        const pieChartOption: any = {
            chart: {
                plotBackgroundColor: null,
                plotBorderWidth: null,
                plotShadow: false,
                type: 'pie',
            },
            title: {
                text: '',
            },
            colors: ['#1abc9c', '#f39c12', '#3498db', '#8e44ad', '#c0392b', '#ecf0f1', '#e74c3c', '#f1c40f'],
            tooltip: {
                headerFormat: '{point.key}<br>',
                pointFormat:
                    '<span style="color:{series.color}>{series.name}</span>: {point.quantity} người<br>Tỷ lệ: {point.percentage:.0f} %',
            },
            accessibility: {
                point: {
                    valueSuffix: '%',
                },
            },
            plotOptions: {
                pie: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: {
                        enabled: true,
                        format:
                            '<span>{point.name}</span>: {point.percentage:.0f} %',
                    }
                },
            },
            series: [
                {
                    name: 'Số lượng',
                    data: _series,
                },
            ],
        };
        return pieChartOption;
    }
    loadProvince() {
        // tslint:disable-next-line: max-line-length
        this.getProvinceACFn = (value: any) => this.provinceService.GetSelectPagingProvinceBySubordinateType({ ProvinceName: value, PageIndex: 1, PageSize: 100 }).pipe(
            map(resp => resp.length > 0 ? resp.map(x => ({ id: x.id, text: x.provinceName })) : [{ id: null, text: 'Không có dữ liệu' }])
        );
        if (!this.provinceSubscription) {
            this.provinceSubscription = this.provinceControl.valueChanges.subscribe(() => {
                this.utilsService.bindOrUnBindTheId(this.commonFilter, 'ProvinceId', this.provinceControl.value);
            });
        }
    }

    changeProvince(control: FormControl) {
        if (control.value) {
            this.provinceControl = control;
        }
    }
    search() {
        this.isloading = true;
        this.schoolService.GetSelectPagingCommunications(this.commonFilter).subscribe(res => {
            this.lstthongtin = res.results ? res.results : [];
            setTimeout(() => {
                this.isloading = false;
            }, 100);
        });
    }
}
